module.exports = __webpack_public_path__ + "static/media/Squat.9acabbb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Squat.jpg
// module id = 34
// module chunks = 1